import React from 'react';

const ICON_URL = `${process.env.PUBLIC_URL || ''}/brand/clinix-icon.svg`;

type ClinixLogoProps = {
  size?: number;
  style?: React.CSSProperties;
};

const ClinixLogo = ({ size = 28, style }: ClinixLogoProps) => (
  <img
    src={ICON_URL}
    alt=""
    aria-hidden="true"
    width={size}
    height={size}
    style={{ display: 'block', flexShrink: 0, ...style }}
  />
);

export default ClinixLogo;
